import { render, staticRenderFns } from "./PayServiceInfo.vue?vue&type=template&id=bde609f6&scoped=true"
import script from "./PayServiceInfo.vue?vue&type=script&lang=ts"
export * from "./PayServiceInfo.vue?vue&type=script&lang=ts"
import style0 from "./PayServiceInfo.vue?vue&type=style&index=0&id=bde609f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../nguonhangchina/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bde609f6",
  null
  
)

export default component.exports